// Share the same value lookup for hover and click so the readouts agree.
export function surfaceReading(info, surface, channel) {
  if (info.picked === false || !info.bitmap || !info.coordinate || !surface) return null;
  const [x, y] = info.bitmap.pixel;
  if (!Number.isInteger(x) || !Number.isInteger(y) || x < 0 || y < 0 || x >= surface.width || y >= surface.height) return null;
  const value = surface.channels[channel]?.[y * surface.width + x];
  if (!Number.isFinite(value)) return null;
  return { estimated: true, value, position: info.coordinate.slice(0, 2) };
}

export function passReading(info, channel) {
  if (info.picked === false) return null;
  const value = info.object?.values[channel];
  if (!Number.isFinite(value)) return null;
  return { ...info.object, estimated: false, value };
}
